import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Visual breadcrumb trail (the JSON-LD version lives in Seo).
 * items: [{ name, path }]
 */
export default function Crumbs({ items = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumb"
      className="mb-8 flex flex-wrap items-center gap-1.5 text-xs text-slate-400"
    >
      <Link to="/" className="inline-flex items-center gap-1 hover:text-emerald-400">
        <Home className="h-3.5 w-3.5" />
        <span>Inicio</span>
      </Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.path} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 text-slate-600" />
            {last ? (
              <span className="font-medium text-slate-200">{it.name}</span>
            ) : (
              <Link to={it.path} className="hover:text-emerald-400">
                {it.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
